module.exports = __webpack_public_path__ + "fae4e4b814159d32685429e36dfbd1f4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/student-icons-quiz.png
// module id = 3607
// module chunks = 0